import React, { useCallback, useRef } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MobileHeaderOnly from "components/headers/light.js";
import ContactIntro from "salad/ContactIntro";
import ContactForm from "salad/ContactForm";
import GrainFooter from "salad/GrainFooter";

export default () => {
    const formRef = useRef(null);

    const handleMessageClick = useCallback(() => {
        formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, []);

    return (
        <div style={{ backgroundColor: "#FFFBDC", minHeight: "100vh" }}>
            <MobileHeaderOnly headerBg="#FFFBDC" drawerBg="#FFFBDC" />
            <AnimationRevealPage>
                <ContactIntro onFormClick={handleMessageClick} />
                <ContactForm ref={formRef} />
                <GrainFooter />
            </AnimationRevealPage>
        </div>
    );
};

